export default __webpack_public_path__ + "static/media/pharmacy.9bde9edf.svg";